import { useDebugModeEnabled } from "./useDebugModeEnabled";

/**
 * 遠隔検収機能（`/remote-assessment` 配下と、そこへの導線）を表示してよいかを返すカスタムフック。
 *
 * 朝日工業でのトライアルが 2026-09-08 に終了し、遠隔で検収を行う人員がいないため利用を停止している。
 * PTZ カメラへの置き換え後に再開を再検討するためコードは削除せず、開発者が状況を確認できるよう
 * デバッグモードが有効なときだけ表示する。
 *
 * 検収結果詳細の検収動画レビュー（HLS）は停止対象ではないため、このフックではゲートしない。
 *
 * `visible` は localStorage を読み終えるまで false になる。表示するときだけ true を見る参照側は
 * `visible` だけで足り、`isInitialized` は「非表示なのでリダイレクトする」側が読み取り前に
 * 発火しないために使う。
 */
export const useRemoteAssessmentVisible = () => {
  const { debugModeEnabled, isInitialized } = useDebugModeEnabled();

  return { visible: debugModeEnabled, isInitialized };
};
